import { createAsyncThunk } from '@reduxjs/toolkit';
import conveyorApi from '../../../api/conveyorApi';
import factoryOptionsApi from '../../../api/factoryOptionsApi';

// ---------------------------------------------------------------------

const REDUCER_NAME = 'conveyorTemplates';

export const GetConveyorTemplates = createAsyncThunk<any, { includeInactive?: boolean } | undefined>(
  `${REDUCER_NAME}/getConveyorTemplates`,
  async (payload, thunkAPI) => {
    const res = await conveyorApi.getConveyorTemplatesWeb(payload?.includeInactive);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetConveyorTemplateById = createAsyncThunk<any, string>(
  `${REDUCER_NAME}/getConveyorTemplateById`,
  async (id, thunkAPI) => {
    const res = await conveyorApi.getConveyorTemplateById(id);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetConveyorStepTemplateById = createAsyncThunk<any, string>(
  `${REDUCER_NAME}/getConveyorStepTemplateById`,
  async (id, thunkAPI) => {
    const res = await conveyorApi.getConveyorStepTemplateById(id);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const UpdateConveyorTemplate = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/updateConveyorTemplate`,
  async ({ id, data }, thunkAPI) => {
    const res = await conveyorApi.update(id, data);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const UpdateConveyorStepTemplate = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/updateConveyorStepTemplate`,
  async ({ id, data }, thunkAPI) => {
    const res = await conveyorApi.updateStepTemplate(id, data);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const CreateConveyorTemplate = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/addConveyorTemplate`,
  async (data, thunkAPI) => {
    const res = await conveyorApi.addConveyorTemplate(data);

    if (res.status === 200) {
      return { ...res.data };
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const ChangeConveyorTemplateInactiveStatus = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/ChangeConveyorTemplateInactiveStatus`,
  async (id, thunkAPI) => {
    const res = await conveyorApi.changeTemplateInactiveStatus(id);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const ChangeConveyorStepTemplateInactiveStatus = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/ChangeConveyorStepTemplateInactiveStatus`,
  async ({ id, status }, thunkAPI) => {
    const res = await conveyorApi.changeInactiveStatus(id, status);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetFactoryIcons = createAsyncThunk(`${REDUCER_NAME}/GetFactoryIcons`, async (___, thunkAPI) => {
  const res = await factoryOptionsApi.getByFactoryConfigOptionValueName('Icons');

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});
